import { useLocalStorage } from "@uidotdev/usehooks";

export function useAfterLoginByOauthPathStorage() {
  const [path, setPath] = useLocalStorage<string>("afterOauthRedirect", "/");

  return {
    path,
    setPath,
  };
}
